import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';
import { SettingsProvider } from './context/settings-context';
import { SearchProvider } from './context/search-context'; // Import SearchProvider
// Import i18n configuration
import './i18n'; // Initialize i18next

const container = document.getElementById('museum-app');
if (!container) throw new Error("Failed to find the 'museum-app' element");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <SettingsProvider>
      <SearchProvider> {/* Wrap App with SearchProvider */}
        <App />
      </SearchProvider>
    </SettingsProvider>
  </React.StrictMode>
);
